import { styled, Card as _Card } from '@mui/material';

const DEFAULT_BORDER_RADIUS= '8px';

export const Card = styled(_Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
  borderRadius: DEFAULT_BORDER_RADIUS,
}));

export default Card;
